import {
  Anchor,
  Avatar,
  Button,
  Divider,
  Group,
  Modal,
  ScrollArea,
  Switch,
  Text,
  Title,
  useMantineTheme,
  Image,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { CardData, SubsData } from "../../../types/types";
import {
  Icon123,
  IconAt,
  IconCalendar,
  IconCalendarTime,
  IconCashBanknote,
  IconCircleCheckFilled,
  IconCircleChevronRightFilled,
  IconCoins,
  IconCreditCard,
  IconPhoneCall,
  IconSort09,
  IconWallet,
} from "@tabler/icons-react";
import classes from "./MangPaymentModal.module.css";
import cardIcon from "../../../assets/img/credit-card.png";
import subIcon from "../../../assets/img/subscription.png";
import singleCard from "../../../assets/img/singleCard.png";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";

interface MangPaymentModal {
  opened: boolean;
  close(): void;
  subId: string;
}

export function MangPaymentModal(props: MangPaymentModal) {
  const [actvCard, setActvCard] = useState<CardData>();
  const [currSub, setCurrSub] = useState<SubsData>();
  const [loading, setLoading] = useState<boolean>();
  const [cards, setCards] = useState<CardData[]>([]);
  const theme = useMantineTheme();
  console.log("init mang payment");
  console.log("actv card: ", actvCard);

  const filteredCards = cards.filter(
    (card: CardData) => card.card_id !== actvCard?.card_id
  );

  useEffect(() => {
    setLoading(true);
    async function getSubCards() {
      console.log("loading: " + loading);
      // setActvCard(undefined);
      try {
        let response = await fetch(
          window.location.origin +
            "/server/client_service/subscriptions/" +
            props.subId
        );

        let resJson = await response.json();
        setCurrSub(resJson[0]);
        setActvCard(resJson[0].card);

        console.log("currSub", resJson[0]);
        console.log("card: ", resJson[0].card);

        response = await fetch(
          window.location.origin + "/server/client_service/cards"
        );
        resJson = await response.json();
        setCards(resJson);

        console.log(cards.length);
        console.log("all cards: ", cards);

        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    }

    if (props.opened) {
      getSubCards();
    }
  }, [props.opened]);

  async function handleSelect(card: CardData) {
    try {
      setLoading(true);
      const response = await fetch(
        window.location.origin +
          "/server/client_service/subscription-payment-method/" +
          currSub?.Subscription_ID,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cardID: card.card_id,
          }),
        }
      );
      const resData = await response.json();
      console.log("switch actv card data:", resData);

      if (!response.ok) {
        throw new Error("Failed to fetch items");
      }

      setActvCard(card);
      setLoading(false);
    } catch (error) {
      console.log("error: ", error);
    }
  }

  return (
    <Modal
      opened={props.opened}
      onClose={props.close}
      size="xl"
      title="Manage Payment"
      centered
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
    >
      {!loading ? (
        <>
          <Group justify="space-around">
            <Group wrap="nowrap">
              <Anchor href="https://www.flaticon.com/free-icons/subscription" target="_blank" rel="noopener noreferrer">
                <Avatar src={subIcon} size={94} radius="md" />
              </Anchor>
              <div>
                <Text fz="xs" tt="uppercase" fw={700} c="dimmed">
                  Current Subscription
                </Text>

                <Text fz="lg" fw={500} className={classes.name}>
                  {currSub?.Name}
                </Text>

                <Group wrap="nowrap" gap={10} mt={3}>
                  {currSub?.Status === "live" ? (
                    <IconCircleCheckFilled
                      stroke={1.5}
                      size={16}
                      className={classes.icon}
                    />
                  ) : (
                    <IconCircleChevronRightFilled
                      stroke={1.5}
                      size={16}
                      className={classes.icon}
                    />
                  )}

                  <Text fz="xs" c="dimmed">
                    {currSub?.Status}
                  </Text>
                </Group>

                <Group wrap="nowrap" gap={10} mt={5}>
                  <IconCoins stroke={1.5} size={16} className={classes.icon} />
                  <Text fz="xs" c="dimmed">
                    {currSub?.Currency_Symbol}
                    {currSub?.Total}
                  </Text>
                </Group>
              </div>
            </Group>
            <Group wrap="nowrap">
              <Anchor href="https://www.flaticon.com/free-icons/credit-card" target="_blank" rel="noopener noreferrer">
                <Avatar src={cardIcon} size={94} radius="md" />
              </Anchor>
              <div>
                <Text fz="xs" tt="uppercase" fw={700} c="dimmed">
                  Current Card
                </Text>

                <Text fz="lg" fw={500} className={classes.name}>
                  **** **** **** {actvCard?.last_four_digits}
                </Text>

                <Group wrap="nowrap" gap={10} mt={5}>
                  <IconCircleCheckFilled
                    stroke={1.5}
                    size={16}
                    className={classes.icon}
                  />
                  <Text fz="xs" c="dimmed">
                    active
                  </Text>
                </Group>
                <Group wrap="nowrap" gap={10} mt={3}>
                  <IconCalendarTime
                    stroke={1.5}
                    size={16}
                    className={classes.icon}
                  />
                  <Text fz="xs" c="dimmed">
                    {actvCard?.expiry_month}/{actvCard?.expiry_year}
                  </Text>
                </Group>
              </div>
            </Group>
          </Group>
          <Divider my="sm" />
          <Text size="lg" p="md" ta="center">
            To change the payment card, choose another from the list below.
          </Text>
          <Divider my="sm" />
          <ScrollArea>
            {filteredCards.length > 0 ? (
              filteredCards.map((card: CardData) => (
                <Group
                  justify="space-between"
                  className={classes.item}
                  wrap="nowrap"
                  gap="xl"
                  p={10}
                >
                  <Group>
                    <Anchor href="https://www.flaticon.com/free-icons/svg" target="_blank" rel="noopener noreferrer">
                      <Image src={singleCard} w={40} h={40} />
                    </Anchor>
                    <div>
                      <Group wrap="nowrap" gap={10}>
                        <IconCalendarTime
                          stroke={1.5}
                          size={16}
                          className={classes.icon}
                        />
                        <Text c="dimmed" size="xs" lh={1} mb={5}>
                          {card.expiry_month}/ {card.expiry_year}
                        </Text>
                      </Group>
                      <Group wrap="nowrap" gap={10} mt={3}>
                        <IconCashBanknote
                          stroke={1.5}
                          size={16}
                          className={classes.icon}
                        ></IconCashBanknote>
                        <Text fw={500} size="sm" lh={1}>
                          **** **** **** {card.last_four_digits}
                        </Text>
                      </Group>
                    </div>
                  </Group>

                  <Button onClick={() => handleSelect(card)} style={{ backgroundColor: "#00ddb3", color: "white" }}>select</Button>
                </Group>
              ))
            ) : (
              <Text p="md" ta="center">
                No alternative cards currently added
              </Text>
            )}
          </ScrollArea>
        </>
      ) : (
        <LoadingSpinner size="md" color="blue" h="10vh" />
      )}
    </Modal>
  );
}
